import { BaseSvgIcon } from './BaseSvgIcon'

export const ChartIcon = (props: any) => {
  const { width = 21, height = 19, fill = 'currentColor', ...rest } = props

  return (
    <BaseSvgIcon width={width} height={height} viewBox="0 0 88 90" fill="none" {...rest}>
      <path
        d="M6.58333 41.4896C5.49995 40.4062 5.49995 38.6562 6.58333 37.5728L27.5555 16.6006C30.0278 14.1284 33.8333 13.4617 37 14.9617L53.5555 22.7396C54.5832 23.2396 55.8611 23.0173 56.6944 22.184L77.4723 1.40628C78.5555 0.322906 80.3333 0.322906 81.4167 1.40628C82.5 2.48948 82.5 4.2395 81.4167 5.32287L60.6111 26.1284C58.1389 28.6007 54.3333 29.2673 51.1666 27.7674L34.6388 19.9896C33.5832 19.4895 32.3056 19.7117 31.4723 20.5172L10.5277 41.4896C9.97214 42.045 9.27769 42.2951 8.55561 42.2951C7.83336 42.2951 7.13892 42.045 6.58333 41.4896Z"
        fill={fill}
      />
      <path
        d="M40.5278 49.4062V83.8507C40.5278 86.934 38.0279 89.4063 34.9722 89.4063H29.4167C26.3612 89.4063 23.8611 86.934 23.8611 83.8507V49.4062C23.8611 46.3507 26.3612 43.8506 29.4167 43.8506H34.9722C38.0279 43.8506 40.5278 46.3507 40.5278 49.4062Z"
        fill={fill}
      />
      <path
        d="M87.75 29.9061V83.8507C87.75 86.934 85.2501 89.4063 82.1945 89.4063H76.6389C73.5834 89.4063 71.0833 86.934 71.0833 83.8507V29.9061C71.0833 26.8507 73.5834 24.3506 76.6389 24.3506H82.1945C85.2501 24.3506 87.75 26.8507 87.75 29.9061Z"
        fill={fill}
      />
      <path
        d="M16.9167 74.2395V83.8507C16.9167 86.934 14.4168 89.4062 11.3611 89.4062H5.80556C2.75007 89.4062 0.25 86.934 0.25 83.8507V74.2395C0.25 71.184 2.75007 68.684 5.80556 68.684H11.3611C14.4168 68.684 16.9167 71.184 16.9167 74.2395Z"
        fill={fill}
      />
      <path
        d="M64.1389 59.0728V83.8507C64.1389 86.934 61.639 89.4063 58.5833 89.4063H53.0278C49.9723 89.4063 47.4722 86.934 47.4722 83.8507V59.0728C47.4722 56.0173 49.9723 53.5173 53.0278 53.5173H58.5833C61.639 53.5173 64.1389 56.0173 64.1389 59.0728Z"
        fill={fill}
      />
    </BaseSvgIcon>
  )
}
